module.exports = __webpack_public_path__ + "static/media/polish-color.e2b86e15.png";